// import { Layers } from "lucide-react";
// import { Link } from "react-router-dom";

// export default function Navbar() {
//   return (
//     <header className="w-full border-b border-gray-100 bg-white/80 backdrop-blur sticky top-0 z-50">
//       <div className="max-w-7xl mx-auto flex items-center justify-between px-6 py-4">
//         <Link to="/" className="flex items-center gap-3 cursor-pointer">
//           <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center">
//             <Layers className="text-white w-5 h-5" />
//           </div>
//           <div>
//             <p className="font-bold text-gray-900 leading-tight">
//               APIC <span className="text-indigo-600">ProtoHub</span>
//             </p>
//             <p className="text-[11px] tracking-wide text-gray-500 leading-tight">
//               ANDHRA PRADESH
//             </p>
//           </div>
//         </Link>

//         <nav className="hidden lg:flex items-center gap-10 text-[15px] font-medium text-slate-600">
//           <Link to="/" className="hover:text-indigo-600 transition">
//             Home
//           </Link>

//           <Link to="/AboutAPIC" className="hover:text-indigo-600 transition">
//             About APIC
//           </Link>

//           <Link to="/Innovatorshome" className="hover:text-indigo-600 transition">
//             Innovators
//           </Link>

//           <Link to="/Facilitieshomepage" className="hover:text-indigo-600 transition">
//             Facilities
//           </Link>

//           <Link to="/machineMarketplace" className="hover:text-indigo-600 transition">
//             Machines
//           </Link>

//           <Link to="/ExpertConnect" className="hover:text-indigo-600 transition">
//             Experts
//           </Link>

//           {/* <Link to="/events" className="hover:text-indigo-600 transition">
//             Events & Programs
//           </Link> */}

//           {/* <Link to="/howitsworksdata" className="hover:text-indigo-600 transition">
//             How it works
//           </Link> */}
//         </nav>

//         <div className="flex items-center gap-6">
//           <Link
//             to="/login"
//             className="text-[15px] font-medium text-slate-700 hover:text-indigo-600 transition"
//           >
//             Login
//           </Link>

//           <Link
//             to="/register"
//             className="flex items-center gap-2 rounded-2xl bg-gradient-to-r from-purple-600 to-blue-600 px-6 py-3 text-white font-semibold shadow-lg hover:shadow-xl transition-all duration-300"
//           >
//             Start your Prototype
//             <span className="text-lg">→</span>
//           </Link>
//         </div>
//       </div>
//     </header>
//   );
// }





import { useState } from "react";
import {
  Layers,
  Menu,
  X,
  ArrowRight
} from "lucide-react";
import { Link } from "react-router-dom";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => setMenuOpen(false);

  const navLinks = [
    { title: "Home", path: "/" },
    { title: "About APIC", path: "/AboutAPIC" },
    { title: "Innovators", path: "/Innovatorshome" },
    { title: "Facilities", path: "/Facilitieshomepage" },
    { title: "Machines", path: "/machineMarketplace" },
    { title: "Experts", path: "/ExpertConnect" },
  ];

  return (
    <>
      <header className="sticky top-0 z-50 w-full border-b border-gray-200 bg-white/90 backdrop-blur-lg">
        <div className="max-w-7xl mx-auto flex items-center justify-between px-4 lg:px-8 py-4">

          {/* Logo */}
          <Link to="/" className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center shadow-md">
              <Layers className="text-white w-5 h-5" />
            </div>

            <div>
              <h2 className="font-bold text-gray-900 text-lg leading-none">
                APIC <span className="text-indigo-600">ProtoHub</span>
              </h2>

              <p className="text-[11px] text-gray-500 tracking-wider">
                ANDHRA PRADESH
              </p>
            </div>
          </Link>

          {/* Desktop Menu */}
          <nav className="hidden lg:flex items-center gap-10 font-medium text-gray-700">
            {navLinks.map((item) => (
              <Link
                key={item.title}
                to={item.path}
                className="hover:text-indigo-600 transition"
              >
                {item.title}
              </Link>
            ))}
          </nav>

          {/* Desktop Buttons */}
          <div className="hidden lg:flex items-center gap-6">
            <Link
              to="/login"
              className="font-medium hover:text-indigo-600"
            >
              Login
            </Link>

            <Link
              to="/register"
              className="flex items-center gap-2 rounded-xl bg-gradient-to-r from-purple-600 to-blue-600 px-6 py-3 text-white font-semibold shadow-lg hover:shadow-xl transition"
            >
              Start your Prototype
              <ArrowRight size={18} />
            </Link>
          </div>

          {/* Mobile Right */}
          <div className="flex lg:hidden items-center gap-3">

            <Link
              to="/register"
              className="rounded-xl bg-gradient-to-r from-purple-600 to-blue-600 px-4 py-2 text-sm font-semibold text-white shadow-md"
            >
              Start
            </Link>

            <button
              onClick={() => setMenuOpen(true)}
              className="w-11 h-11 rounded-xl border flex items-center justify-center hover:bg-gray-100 transition"
            >
              <Menu size={24} />
            </button>

          </div>

        </div>
      </header>

      {/* Overlay */}
      <div
        onClick={closeMenu}
        className={`fixed inset-0 bg-black/40 backdrop-blur-sm z-40 transition-opacity duration-300 ${
          menuOpen
            ? "opacity-100 visible"
            : "opacity-0 invisible"
        }`}
      />

      {/* Sidebar */}
      <div
        className={`fixed top-0 right-0 h-full w-80 max-w-[85%] bg-white shadow-2xl z-50 transform transition-transform duration-300 ease-in-out ${
          menuOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >

        {/* Header */}
        <div className="flex items-center justify-between border-b p-5">

          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center">
              <Layers className="text-white w-5 h-5" />
            </div>

            <div>
              <h2 className="font-bold">
                APIC
                <span className="text-indigo-600">
                  {" "}
                  ProtoHub
                </span>
              </h2>

              <p className="text-xs text-gray-500">
                Andhra Pradesh
              </p>
            </div>
          </div>

          <button
            onClick={closeMenu}
            className="w-10 h-10 rounded-lg hover:bg-gray-100 flex items-center justify-center"
          >
            <X size={22} />
          </button>

        </div>

        {/* Links */}
        <div className="p-6 flex flex-col">

          {navLinks.map((item) => (
            <Link
              key={item.title}
              to={item.path}
              onClick={closeMenu}
              className="py-4 border-b text-gray-700 font-medium hover:text-indigo-600 transition"
            >
              {item.title}
            </Link>
          ))}

          <Link
            to="/login"
            onClick={closeMenu}
            className="mt-6 py-3 text-center border rounded-xl font-semibold hover:bg-gray-50"
          >
            Login
          </Link>

          <Link
            to="/register"
            onClick={closeMenu}
            className="mt-4 flex justify-center items-center gap-2 rounded-xl bg-gradient-to-r from-purple-600 to-blue-600 py-3 text-white font-semibold shadow-lg"
          >
            Start your Prototype
            <ArrowRight size={18} />
          </Link>

        </div>

      </div>
    </>
  );
}